import { cx } from "../../lib/cx.js";
import { DialogLayer } from "../_dialog/DialogLayer.js";
/* empty css           */
import { jsx } from "react/jsx-runtime";
//#region src/components/Drawer/Drawer.tsx
/**
* A modal panel at the side of the screen, full height, for a task that takes a few
* steps (Import org structure, Upload files). The page behind is inert, focus is trapped
* inside and returns to where it was on close. Render it where it's used and toggle
* `open`; it portals into the ThemeRoot.
*/
function Drawer({ open, onClose, title, description, children, footer, side = "right", size = "md", dismissable = true, initialFocusRef, "aria-label": ariaLabel, closeLabel = "Close panel", className, container }) {
	if (!open) return null;
	return /* @__PURE__ */ jsx(DialogLayer, {
		block: "ds-drawer",
		panelClassName: cx("ds-drawer", `ds-drawer--${side}`, `ds-drawer--${size}`, className),
		onClose,
		title,
		description,
		footer,
		dismissable,
		initialFocusRef,
		"aria-label": ariaLabel,
		closeLabel,
		container,
		children
	});
}
//#endregion
export { Drawer };

//# sourceMappingURL=Drawer.js.map